/**
 * Main entry point for the M247 Digital Signage application
 * This file handles initialization including:
 * - React DOM rendering
 * - Service worker registration
 * - Mock API setup for development
 * - Web vitals reporting
 */
import "./polyfills"; // must stay first: runtime.ts fetches env.js on module load
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "./index.css";
import { setupMockApi } from "./services/mockData";
import reportWebVitals from "./reportWebVitals";
import { runtimeConfig, ensureConfigLoaded } from "./config/runtime";

// Initialize runtime configuration and then start the app
async function startApp() {
  // Ensure config is loaded before starting the app
  await ensureConfigLoaded();

  // Configurable sync interval (in milliseconds)
  const PRAYER_SYNC_INTERVAL = runtimeConfig.prayerSyncInterval;

  // Setup mock API for development
  setupMockApi();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}

// Start the application
startApp();
